import React, { useCallback, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Edit16 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import { schema, uiSchema, translateSchema } from './config';
import BuilderForm from '../FormCarbon';
import DataTable from '../DataTable';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

import {
  postTempConfigFile,
  transactTempConfigFile,
  setTempConfigFile,
  setConfigFile
} from '../../../actions';
import './Settings.css';

const Settings = ({ configFile, tempConfigFile }) => {
  const config = tempConfigFile || configFile;
  const [open, setOpen] = React.useState(false);
  const [notification, setNotification] = React.useState(null);
  const [formData, setFormData] = React.useState({});
  const isDisabled = tempConfigFile.lastUpdate <= configFile?.lastUpdate;
  const row = [
    {
      id: 'settings',
      name: config.name.replace('app-', '') || '',
      email: config.email || '',
      phoneNumber: config.phoneNumber || '',
      address: config.address || '',
      logo: !!config.logo,
      trackingInfo: !!config.trackingInfo
    }
  ];

  const headers = [
    { header: 'Nombre', key: 'name' },
    { header: 'Email', key: 'email' },
    { header: 'Teléfono', key: 'phoneNumber' },
    { header: 'Dirección', key: 'address' },
    { header: 'Logotipo', key: 'logo' },
    { header: 'TrackingInfo', key: 'trackingInfo' }
  ];

  useEffect(() => {
    translateSchema(schema);
  }, []);

  const dispatch = useDispatch();
  const editTempConfigFile = useCallback(
    configFile => dispatch(setTempConfigFile(configFile)),
    [dispatch]
  );

  const editConfigFile = useCallback(
    configFile => dispatch(setConfigFile(configFile)),
    [dispatch]
  );

  const onEdit = () => {
    const info = {
      id: 'settings',
      email: config.email,
      phoneNumber: config.phoneNumber,
      address: config.address,
      logo: config.logo,
      trackingInfo: config.trackingInfo
    };
    setFormData(info);
    setOpen(true);
  };

  const onSave = async ({ formData }) => {
    const configFile = {
      ...config,
      ...formData
    };
    const res = await postTempConfigFile(configFile);
    if (res.message === 'OK') {
      editTempConfigFile(configFile);
      setNotification({
        type: 'success',
        message: funcTranslateHelper('Builder.Message.realizado')
      });
    } else {
      setNotification({
        type: 'error',
        message: funcTranslateHelper('Builder.Message.error')
      });
    }
    setOpen(false);
    setTimeout(() => setNotification(null), 2000);
  };

  const saveToBlockchain = async () => {
    const res = await transactTempConfigFile();
    if (res.message === 'OK') {
      editConfigFile(tempConfigFile);
      setNotification({
        type: 'success',
        message: funcTranslateHelper('Builder.Message.realizado')
      });
    } else {
      setNotification({
        type: 'error',
        message: funcTranslateHelper('Builder.Message.error')
      });
    }
    setTimeout(() => setNotification(null), 2000);
  };

  if (open) {
    return (
      <BuilderForm
        onClose={() => setOpen(false)}
        onEdit={onSave}
        open={open}
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        title={funcTranslateHelper('Builder.Settings.form.titulo')}
        subtitle={funcTranslateHelper('Builder.Settings.form.subtitulo')}
        primaryButtonText={funcTranslateHelper('Guardar')}
        secondaryButtonText={funcTranslateHelper('Cancelar')}
      />
    );
  }

  return (
    <div>
      <div className='settings-blockchain-action'>
        <div>
          <h4>Blockchain</h4>
          <p className='bx--data-table-header__description'>
            {funcTranslateHelper('Builder.Settings.SettingDescripcion')}
          </p>
        </div>
        <div>
          <Button
            kind='primary'
            disabled={isDisabled}
            onClick={saveToBlockchain}
            type='button'
          >
            {funcTranslateHelper(
              'Builder.Settings.btn.Guardar en Blockchain'
            )}
          </Button>
        </div>
      </div>
      <div className='data-table-container'>
        {funcTranslateHelper(
          'Builder.Settings.btn.Elija el tema de colores para la app'
        )}
      </div>
      <div className='data-table-container'>
        <DataTable
          title='Settings'
          subtitle='Subtitle'
          headers={headers}
          rows={row}
          handleOpen={onEdit}
          notification={notification}
          allowEdit={false}
          buttonText={
            <span className='data-table-custom-btn'>
              {funcTranslateHelper(
                'Builder.Settings.btn.Editar informacion'
              )}
              <Edit16 fill='#fff' />
            </span>
          }
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    configFile: state.configFile,
    tempConfigFile: state.tempConfigFile
  };
};

export default connect(mapStateToProps)(Settings);
